export default "__VITE_ASSET__LQPMdeOy__"